import clsx from 'clsx';

import { ButtonSkeletonProps } from '../../../components/Button/skeleton';
import ToolbarButtonSkeleton from '../../ToolbarButton/skeleton';
import { textFormattingButtonsClasses } from './styles';

export interface TextFormattingButtonsSkeletonProps extends ButtonSkeletonProps {
  classes?: Partial<typeof textFormattingButtonsClasses>;
}

const TextFormattingButtonsSkeleton = ({ className, classes, ...props }: TextFormattingButtonsSkeletonProps) => {
  return (
    <>
      <ToolbarButtonSkeleton
        {...props}
        className={clsx(
          textFormattingButtonsClasses.toolbarButton,
          classes?.toolbarButton,
          textFormattingButtonsClasses.bold,
          classes?.bold
        )}
      />
      <ToolbarButtonSkeleton
        {...props}
        className={clsx(
          textFormattingButtonsClasses.toolbarButton,
          classes?.toolbarButton,
          textFormattingButtonsClasses.italic,
          classes?.italic
        )}
      />
      <ToolbarButtonSkeleton
        {...props}
        className={clsx(
          textFormattingButtonsClasses.toolbarButton,
          classes?.toolbarButton,
          textFormattingButtonsClasses.underline,
          classes?.underline
        )}
      />
    </>
  );
};

export default TextFormattingButtonsSkeleton;
